import { useQuery } from 'react-query';
import { getMoneyLenderTiles } from 'api/moneyLenderTiles';
import { MoneyLenderTilesProps } from 'types/MoneyLenders';
import { getPartyId } from 'utils/partyId/setPartyId';
import { isLoggedInAsObserver } from 'auth/utils';

export const useQueryMoneyLendersTiles = () => {
  const isObserver: boolean = isLoggedInAsObserver();
  let isCallEnabled: boolean = true;

  if (isObserver) {
    const partyId: string | null = getPartyId();
    isCallEnabled = !!partyId;
  }

  return useQuery(
    ['moneyLenders-tiles'],
    (): Promise<MoneyLenderTilesProps[]> => getMoneyLenderTiles(),
    {
      enabled: isCallEnabled,
    }
  );
};
